<div class="calendar-form-wrapper" [ngClass]="{ 'disabled': isCalendarDisabled && !disableFullOpacity,
  'disable-full-opacity': disableFullOpacity }">
  <span class="due-date" *ngIf="!displayInputArea && showDateLabel">
    {{ selectedDate ? (getDateInDateFormat(selectedDate) | date) : placeHolder }}
  </span>
  <form class="form-inline calendar-form" [ngClass]="{ 'w-100': toggleButton && displayInputArea }">
    <div class="form-group" [ngClass]="{'w-100': toggleButton}">
      <div class="input-group timeline-datepicker-width"
        [ngClass]="{'show-navigation' : toggleButton, 'w-100' : toggleButton}">
        <input class="form-control"
          [ngClass]="{'display-input-area': toggleButton && displayInputArea }" type="text"
          id="{{dateType}}" name="{{dateType}}" [dayTemplate]="iniDateCustomDay"
          [disabled]="isCalendarDisabled || disableFullOpacity" placeholder="{{placeHolder}}"
          (dateSelect)="dateUpdated($event)" ngbDatepicker #dateInput="ngbDatepicker"
          [outsideDays]="'hidden'" [autoClose]="toggleButton" [(ngModel)]="selectedDate"
          [minDate]="inputMinDate" [maxDate]="inputMaxDate" [readonly]="isReadOnly"
          [navigation]="navigation" [firstDayOfWeek]="firstDayOfWeek"
          [datepickerClass]="dateType === 'deadlineDateEdit' ? 'ai-risk-deadline-datepicker' : ''" />
        <div *ngIf="toggleButton" class="input-group-append" (click)="calendarToggle()">
          <div class="calendar-icon" cygovSvgIcon [svgName]="'calendar-icon'"></div>
        </div>
      </div>
    </div>
  </form>
  <ng-template #iniDateCustomDay let-date let-currentMonth="currentMonth" let-selected="selected"
    let-disabled="disabled" let-focused="focused">
    <div [ngClass]="{'blue-text': isDataFound(date)}" class="custom-day" [class.focused]=" focused"
      [class.bg-primary]=" selected" [ngStyle]="getDivStyles(date.day)"
      [class.text-muted]="disabled">
      {{ date.day }}
    </div>
  </ng-template>
</div>